<ng-container *ngIf="goals && goals.length > 0; else noGoals">
  <div class="goals-table">
    <div class="goal-card" *ngFor="let goal of goalsFormArray.controls; let i = index">
      <div class="goals-row goals-grid">
        <div class="goal title">
          <p class="title">{{ 'goals.title' | translate }}</p>
          <span class="value title"><b>{{ getTitle(goal.value) }}</b></span>
        </div>
        <div class="goal status" *ngIf="!isConsentValid">
          <p class="title">{{ 'goals.status' | translate }}</p>
          <span class="value" [ngStyle]="{'background-color': getBackGroundColor(goal.value),
            'border-radius': '15px', 'color': getColor(goal.value), 'padding': '8px', 'font-size': '12px'
          }">{{ getStatusLabel(goal.value) | translate }}</span>
        </div>
        <div class="goal" [ngStyle]="{'width': (45 / goalsFilteredQuestions.length) + '%'}"
          *ngFor="let question of goalsFilteredQuestions">
          <p class="title">{{ getText(question.globalizationConfig, 'title') }}</p>
          <span class="value">{{ getLabelText(question, goal.get('field' + question.order)?.value) }}</span>
        </div>
      </div>

      <div class="goal-description">
        <div class="label">{{ 'goals.description' | translate }}</div>
        <div class="box" [ngStyle]="{ 'border': (processType === ProcessType.GoalInputs
                                                || processType === ProcessType.GoalInputValidation)
                                                && canEditGoals ? '1px solid var(--ion-color-lightgray)' : 'none' }"
                        [innerHTML]="getDescription(goal.value)"></div>
      </div>

      <div class="actions" *ngIf="canEditGoals || showValidatedBadge">
        <p *ngIf="hasActionButtons(goal.value)">{{ 'generic.actions' | translate }}</p>
        <ion-buttons class="buttons-group">

          <!-- GoalInputs: text buttons for edit + remove -->
          <ng-container *ngIf="processType === ProcessType.GoalInputs && canEditGoals">
            <ion-button fill="solid" color="danger"
              (click)="remove.emit({ goal: goal.value })">{{ 'goalsInput.remove' | translate }}</ion-button>
            <ion-button fill="solid" color="dark"
              (click)="edit.emit({ goal: goal.value })">{{ 'goalsInput.update' | translate }}</ion-button>
          </ng-container>

          <!-- GoalInputValidation / GoalsReviewValidation: Aprovar + Recusar text+icon buttons -->
          <ng-container *ngIf="processType === ProcessType.GoalInputValidation || processType === ProcessType.GoalsReviewValidation">
            <ng-container *ngIf="isPersistedRefused(goals[i]); else interactiveRefuseState">
              <ion-button mode="ios"
                fill="solid"
                color="danger"
                class="refuse-button is-selected choice-button refuse-choice"
                [class.is-selected]="goals[i]?.approved === false"
                [disabled]="true">
                <img class="goal-action-icon"
                  src="assets/imgs/goals/close.svg"
                  alt="Close" />
                {{ 'goalsInput.refuse' | translate }}
              </ion-button>
            </ng-container>
            <ng-template #interactiveRefuseState>
              <ng-container *ngIf="!isRefuseMode(goals[i]); else refuseModeButtons">
                <ion-button mode="ios"
                  [fill]="goals[i]?.approved === true ? 'solid' : 'outline'"
                  color="primary"
                  class="choice-button approve-choice"
                  [class.is-selected]="goals[i]?.approved === true"
                  (click)="onApprove(goals[i])">
                  <img class="goal-action-icon"
                    src="assets/imgs/goals/check.svg"
                    alt="Check"
                    [class.is-solid]="goals[i]?.approved === true" />
                  {{ 'goalsInput.approve' | translate }}
                </ion-button>
                <ion-button mode="ios"
                  class="refuse-button"
                  [class.is-selected]="goals[i]?.approved === false"
                  [fill]="goals[i]?.approved === false ? 'solid' : 'outline'"
                  (click)="startRefuseMode(goals[i])">
                  <img class="goal-action-icon"
                    src="assets/imgs/goals/close.svg"
                    alt="Close" />
                  {{ 'goalsInput.refuse' | translate }}
                </ion-button>
              </ng-container>
            </ng-template>
            <ng-template #refuseModeButtons>
              <ion-button mode="ios"
                fill="outline"
                color="medium"
                (click)="cancelRefuseMode(goals[i])">
                <img class="goal-action-icon"
                  src="assets/imgs/goals/replay.svg"
                  alt="Replay" />
                {{ 'generic.goBack' | translate }}
              </ion-button>
              <ion-button mode="ios"
                class="refuse-button is-selected"
                fill="solid"
                [disabled]="true">
                <img class="goal-action-icon"
                  src="assets/imgs/goals/close.svg"
                  alt="Close" />
                {{ 'goalsInput.refuse' | translate }}
              </ion-button>
            </ng-template>
          </ng-container>

          <!-- GoalInputValidation: Editar meta text+icon button -->
          <ng-container *ngIf="processType === ProcessType.GoalInputValidation && canEditGoals && !isRefuseMode(goals[i])">
            <ion-button class="edit-goal-button edit-goal-button-right" fill="outline" color="dark" mode="ios"
              (click)="edit.emit({ goal: goal.value })">
              <i class="bp-edit"></i>
              {{ 'goalsInput.update' | translate }}
            </ion-button>
          </ng-container>

          <!-- GoalsReview: Editar meta + Deletar meta text+icon buttons -->
          <ng-container *ngIf="processType === ProcessType.GoalsReview && canEditGoals && !isRefuseMode(goals[i])">
            <ion-button class="edit-goal-button" fill="outline" color="dark" mode="ios"
              (click)="edit.emit({ goal: goal.value })">
              <i class="bp-edit"></i>
              {{ 'goalsInput.update' | translate }}
            </ion-button>
            <ion-button *ngIf="canDeleteGoal" class="delete-goal-button" fill="outline" color="danger" mode="ios"
              (click)="delete.emit({ goal: goal.value })">
              <img class="goal-action-icon delete-icon"
                src="assets/imgs/goals/delete-outline.svg"
                alt="Delete" />
              {{ 'goalsInput.remove' | translate }}
            </ion-button>
          </ng-container>

          <!-- GoalsReviewValidation: Deletar meta text+icon button -->
          <ng-container *ngIf="processType === ProcessType.GoalsReviewValidation && canDeleteGoal">
            <ion-button class="delete-goal-button" fill="outline" color="danger" mode="ios"
              (click)="delete.emit({ goal: goal.value })">
              <img class="goal-action-icon delete-icon"
                src="assets/imgs/goals/delete-outline.svg"
                alt="Delete" />
              {{ 'goalsInput.remove' | translate }}
            </ion-button>
          </ng-container>

          <!-- Validated badge (GoalsReview) -->
          <ion-button *ngIf="showValidatedBadge && goals[i]?.status === GoalStatusEnum.ReviewAccepted"
            color="success" fill="clear" mode="ios">
            {{ 'generic.validated' | translate }}
            <img class="goal-action-icon"
              src="assets/imgs/goals/check.svg"
              alt="Check" />
          </ion-button>

        </ion-buttons>
        <!-- COMENTADO POR NÃO APARECER EM NENHUM LOCAL EM PROD, E APARENTAR NÃO SER USADO
         <div class="goalView" *ngIf="!canApproveGoals && processType === ProcessType.GoalInputValidation">
          <a (click)="viewGoalProgress.emit({ goal: goal.value })">
            {{ 'dashboard.See' | translate }}
          </a>
        </div> -->
      </div>

      <ion-col *ngIf="goals[i]?.approved === false &&
        (processType === ProcessType.GoalInputValidation || processType === ProcessType.GoalsReviewValidation) &&
        (canEditGoals || goals[i]?.managerComment)">
        <ion-item lines="none" feedback [class.no-border]="!canEditGoals">
          <ion-label position="stacked">
            {{'goalsValidation.feedback' | translate}}
          </ion-label>
          <ion-textarea [placeholder]="'goalsValidation.rejectionInputPlaceholder' | translate"
            [(ngModel)]="goals[i].managerComment"
            [readonly]="!canEditGoals"></ion-textarea>
        </ion-item>
      </ion-col>
    </div>
  </div>
</ng-container>
<ng-template #noGoals>
  <!-- <p>{{ 'goalsInput.noGoals' | translate }}</p> -->
</ng-template>